import Resource from '@/api/resources/Resource'

class UserappRoleConfigurationServices extends Resource {
    async getUserappRolesByUserappId(userappId) {
        const response = await this.axios.get(`/configuration/userapps/${userappId}/userappRoles`)
        return response.data
    }
    async createUserappRole(userappRoleCreateRequest) {
        const response = await this.axios.post(`/configuration/userappRoles`, userappRoleCreateRequest)
        return response.data
    }
    async deleteUserappRole(userappRoleId) {
        const response = await this.axios.delete(`/configuration/userappRoles/${userappRoleId}`)
        return response.data
    }
}

export default new UserappRoleConfigurationServices()
